<template>
    <div>
        <b-modal
            id="deposit-slip-image"
            size="lg modal-xlg"
            hide-footer
            ref="ViewDepositSlipImage"
            no-close-on-backdrop
            no-close-on-esc>
            <b-container fluid class="px-0">
                <img
                    style="width: 100%;"
                    :src="depositSlipImage"
                    alt="Deposit Slip"
                />
            </b-container>
        </b-modal>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "NewProduct",
    props: ["status", "depositSlipImage"],
    components: {},
    data() {
        return {};
    },
    computed: {
        ...mapState("estoreOrders", [
            "loading",
            "errors",
            "modal",
            "orderDetails"
        ])
    },
    methods: {
        closeModal: function() {
            this.$store.commit("estoreOrders/setModal", {
                type: "view_order",
                status: false
            });
        }
    },
    watch: {
        status: function(status) {
            if (status === true) {
                this.$refs.ViewDepositSlipImage.show();
                this.$store.commit("estoreOrders/errors", null);
            } else {
                this.$refs.ViewDepositSlipImage.hide();
            }
        }
    }
};
</script>
